/**
 * Created by bainuo on 2017/12/15.
 */
export default {
  name:'home',
  path:'/home',
  meta: {
    title: '主页',
    breadcrumb: false,
  },
  component: (resolve) => require(['@/views/Home'], resolve),
}



// WEBPACK FOOTER //
// ./src/router/home.js